import React, { FunctionComponent, ReactElement } from "react";
import "./style.scss";

const CartButtonSpinner: FunctionComponent = (): ReactElement => {
  return <div className="CartButtonSpinner" />;
};

export default React.memo(CartButtonSpinner);
